import React from "react";
import PropTypes from "prop-types";

import FormInfo from "./FormInfo";
import FullScreenLoader from "../FullScreenLoader";
import { Button } from "@material-ui/core";

const ViewForm = (props) => (
  <form>
    <fieldset disabled={!props.onSubmit}>
      {props.children}
      <br />
      <FormInfo
        successMessage={props.successMessage}
        errorMessage={props.errorMessage}
      />
      {props.onSubmit && (
        <Button
          fullWidth
          variant="contained"
          color="primary"
          disabled={props.isFetching}
          onClick={props.onSubmit}
        >
          {props.submitText}
        </Button>
      )}
    </fieldset>
    {props.isFetching && <FullScreenLoader />}
  </form>
);

ViewForm.propTypes = {
  onSubmit: PropTypes.func,
  isFetching: PropTypes.bool.isRequired,
  children: PropTypes.node,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  submitText: PropTypes.string,
};

export default ViewForm;



// WEBPACK FOOTER //
// ./src/components/forms/ViewForm.js